import fileSaver from 'file-saver'
import Vue from 'vue'
const requests = {
  fileUploading: null
}

export default {
  getExcelLayerList({ commit, getters }, params) {
    return Vue.http
      .get(getters.endpoint.excelLayers.layersList, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setExcelLayersKeyValue', {
          key: 'excelLayerList',
          value: r.body.result
        })
      })
  },
  getExcelLayersIconList({ commit, getters }, params) {
    return Vue.http
      .get(getters.endpoint.icon, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setExcelLayersKeyValue', {
          key: 'excelLayerIconList',
          value: r.body.results
        })
      })
  },
  getExcelLayersColorList({ commit, getters }, params) {
    return Vue.http
      .get(getters.endpoint.excelLayers.colors, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        const value = []
        Object.keys(r.body).forEach((hex) => {
          value.push({
            id: hex,
            hex,
            name: r.body[hex]
          })
        })
        commit('setExcelLayersKeyValue', {
          key: 'excelLayerColorList',
          value
        })
      })
  },
  getExcelLayerSettings({ commit, getters, dispatch }, params) {
    return Vue.http
      .get(getters.endpoint.excelLayers.layerSettings, {
        params: {
          id: params.id,
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        r.body[0].headers = Array.isArray(r.body[0].headers)
          ? r.body[0].headers.map((v) => {
              return typeof v === 'string'
                ? {
                    id: v,
                    show: true
                  }
                : v
            })
          : []
        commit('setExcelLayersKeyValue', {
          key: 'excelLayerSettings',
          value: r.body[0]
        })
        return r.body[0]
      })
  },

  /**
   * Новое действие, которое просто загружает настройки слоя по идентификатору
   * @param {*} param0
   * @param {*} param1
   * @returns
   */
  loadExcelLayerSettings({ commit, getters }, { id }) {
    return Vue.http
      .get(getters.endpoint.excelLayers.layerSettings, {
        params: {
          id,
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((result) => {
        return result.body && result.body.length > 0 ? result.body[0] : null
      })
  },

  updateExcelLayerSettings({ commit, getters, dispatch }, params) {
    return Vue.http.post(
      getters.endpoint.excelLayers.updateLayerSettings,
      { ...params.params },
      {
        params: {
          id: params.id,
          workspace: getters.workspace,
          version: getters.version
        }
      }
    )
  },
  deleteExcelLayer({ commit, getters }, params) {
    return Vue.http
      .delete(getters.endpoint.excelLayers.deleteLayer, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        if (getters.excelLayerList.length > 0) {
          //get layers list
        }
      })
  },
  createExcelLayer({ commit, dispatch, getters }, params) {
    const multipart = new FormData()
    multipart.append('file', params.file)
    return Vue.http.post(getters.endpoint.excelLayers.addLayer, multipart, {
      params: {
        active: params.active || false,
        layer_name: params.name,
        icon_id: params.icon,
        color: params.color,
        is_trip: params.is_trip ? params.is_trip : '',
        allowed_workspaces: params.allowed_workspaces.join(',')
      }
    })
  },
  getExcelLayerFile({ commit, getters }, params) {
    return Vue.http
      .get(getters.endpoint.excelLayers.layerFile, {
        responseType: 'blob',
        params: {
          workspace: getters.workspace,
          version: getters.version,
          id: params.id
        }
      })
      .then((r) => {
        fileSaver.saveAs(r.body, params.name)
      })
  },

  getExcelLayerObjectList({ commit, getters }, params) {
    return Vue.http
      .get(getters.endpoint.excelLayers.layerObjectList, {
        params: {
          limit: params.limit,
          offset: params.offset,
          id: params.id,
          workspace: getters.workspace,
          version: getters.version,

          //Передаем этот параметр, чтобы сервис игнорировал фильтр карты
          // и отдал список объектов целиком, по умолчанию этот параметр true
          is_map: false
        }
      })
      .then((r) => {
        commit('setExcelLayersKeyValue', {
          key: 'excelLayerObjectList',
          value: {
            count: r.body.count,
            offset: params.offset,
            limit: params.limit,
            //limit: r.body.count,
            result: r.body.result
          }
        })
      })
  },
  getExcelLayerObject({ commit, getters }, params) {
    return Vue.http
      .get(getters.endpoint.excelLayers.layerObject, {
        params: {
          id: params.id,
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setExcelLayersKeyValue', {
          key: 'excelLayerObject',
          value: r.body
        })
      })
  },
  updateExcelObject({ commit, getters, dispatch }, params) {
    return Vue.http.post(
      getters.endpoint.excelLayers.updateLayerObject,
      { ...params.params },
      {
        params: {
          id: params.id,
          workspace: getters.workspace,
          version: getters.version
        }
      }
    )
  },
  deleteExcelObject({ commit, getters, dispatch }, params) {
    return Vue.http.delete(getters.endpoint.excelLayers.deleteLayer, {
      params: {
        ...params,
        workspace: getters.workspace,
        version: getters.version
      }
    })
  },
  clearExcelLayers({ commit }) {
    commit('setExcelLayersKeyValue', {
      key: 'excelLayerList',
      value: []
    })
    commit('setExcelLayersKeyValue', {
      key: 'excelLayerObject',
      value: null
    })
    commit('setExcelLayersKeyValue', {
      key: 'excelLayerSettings',
      value: null
    })
    commit('setExcelLayersKeyValue', {
      key: 'excelLayerObjectList',
      value: []
    })
  },

  /**
   * Загрузка истории изменений инфослоя
   * @param {*} param0
   * @param {*} param1
   * @returns
   */
  loadExcelLayerHistory({ getters }, { layerId, ...params }) {
    return Vue.http.get(getters.endpoint.excelLayers.history, {
      params: {
        id: layerId,
        workspace: getters.workspace,
        version: getters.version,
        ...params
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/excel-layers/actions.js